import { useParams } from 'react-router-dom';

import { SpaceDiscriminator, useGetResidentialUnitsByIdQuery } from '@client/api';

import { CommonAreasListCard } from '../../../../components/common-areas-list-card/common-areas-list-card.component';
import { SpaceFilesCard } from '../../../../components/space-files-card/space-files-card.component';
import { ResidentialUnitRoomsCard } from '../components/residential-unit-rooms/residential-unit-rooms-card.component';
import { SpaceAreaHistoryCard } from '../components/space-area-history/space-area-history-card.component';
import { SpaceInformationCard } from '../components/space-information/space-information-card.component';

export const ResidentialUnitView = () => {
  const { spaceId, discriminator } = useParams<{ spaceId: string; discriminator: SpaceDiscriminator }>();

  const { data: space, isFetching } = useGetResidentialUnitsByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <SpaceInformationCard space={space} isFetching={isFetching} discriminator={discriminator} />

        <SpaceAreaHistoryCard spaceId={spaceId} />

        <CommonAreasListCard />

        <ResidentialUnitRoomsCard />

        <SpaceFilesCard spaceId={spaceId} />
      </div>
    </div>
  );
};
